import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addWasteSegregation = (wasteSegregation) => {
  vehicle = Object.assign({}, vehicle) 
  const promises = [];
  return http
    .post(        {
         })
    .then((result) => {
        wasteSegregation = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("WasteSegregation.create-error:\n", error);
      throw error;
    });
};

internals.updateWasteSegregation = (_id,wasteSegregation) => {
 
  return http
    .put( {
     
    })
    .then((result) => {
        wasteSegregation = result.data;
      return vehicle;
    })
    .catch((error) => {
      console.error("WasteSegregation.updateVehicle-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/wastesegregation.service.js